module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-overlayer"
  }, [_c('div', {
    staticClass: "popup"
  }, [_c('a', {
    staticClass: "close-btn",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]), _vm._v(" "), _c('h2', [_vm._v("Vonalkód igénylés")]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('inputbox', {
    key: "amount",
    attrs: {
      "errors": _vm.errors,
      "regexp_filter": "[0-9]+",
      "label": "Vonalkód darabszám",
      "id": "amount"
    },
    model: {
      value: (_vm.request.amount),
      callback: function($$v) {
        _vm.$set(_vm.request, "amount", $$v)
      },
      expression: "request.amount"
    }
  }), _vm._v(" "), _c('textareabox', {
    key: "comment",
    attrs: {
      "errors": _vm.errors,
      "label": "Megjegyzés",
      "id": "comment"
    },
    model: {
      value: (_vm.request.comment),
      callback: function($$v) {
        _vm.$set(_vm.request, "comment", $$v)
      },
      expression: "request.comment"
    }
  }), _vm._v(" "), _c('comboboxV2', {
    attrs: {
      "errors": _vm.errors,
      "label": "Csoport",
      "id": "group_id",
      "name": "group_id",
      "options": _vm.groups
    },
    model: {
      value: (_vm.request.group_id),
      callback: function($$v) {
        _vm.$set(_vm.request, "group_id", $$v)
      },
      expression: "request.group_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 align-right"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.save
    }
  }, [(_vm.loading) ? _c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }) : _c('span', [_vm._v("Mentés")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36baad41"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/barcode/popup.vue
// module id = 294
// module chunks = 0